// eslint-disable-next-line @typescript-eslint/explicit-function-return-type
async function init() {
  import("./bootstrap").then((bootstrap) => bootstrap.default());
}

init();
